export default "__VITE_ASSET__27787f26__"